import { Typography,theme } from "antd";
import React from "react";
import { regularIrregularOptions } from "../../../../Options/commonOptions";
import { pulseVolumeOptions } from "../../../../Options/genExamOptions";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";
import { hexToRgba } from "../../../../../../helpers/utility";

const Pulse = ({ form }) => {
    const { token } = theme.useToken(); 
  
  return (
    <>
      <Typography>Pulse</Typography>
      <div className="subsection-card"
      style={{
                                borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
                                background: "transparent",
                                marginTop: "8px",
                              }}>
        <DeselectableRadioGroup
          name={["pulse_details", "pulse_regular"]}
          options={regularIrregularOptions}
          form={form}
        />

        <DeselectableRadioGroup
          name={["pulse_details", "pulse_volume"]}
          options={pulseVolumeOptions}
          form={form}
        />
      </div>
    </>
  );
};

export default Pulse;
